module.exports = __webpack_public_path__ + "img/noPermission.b46e595b.png";